import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-[130px] l:mt-[155px]" }

import List from '@/components/Excursions/List.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Excursions',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(List)
  ]))
}
}

})